import React from "react";

type RevealTextProps = {
  lines: string[];
  className?: string;
  lineClassName?: string;
  delay?: number;
  as?: "div" | "h1" | "h2" | "h3";
};

export const RevealText: React.FC<RevealTextProps> = ({ lines, className = "", lineClassName = "", delay = 0, as = "div" }) => {
  const Tag = as as any;
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <div key={i} className="overflow-hidden pb-[0.15em]">
          <div
            className={`animate-reveal-line ${lineClassName}`}
            style={{ animationDelay: `${delay + i * 0.05}s` }}
          >
            {line}
          </div>
        </div>
      ))}
    </Tag>
  );
};

type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  y?: number;
  as?: "div" | "h1" | "h2" | "h3";
};

export const Reveal: React.FC<RevealProps> = ({ children, className = "", delay = 0, as = "div" }) => {
  const Tag = as as any;
  return (
    <Tag className={`animate-fade-up ${className}`} style={{ animationDelay: `${delay}s` }}>
      {children}
    </Tag>
  );
};
